export * as chatSettings from '@wix/auto_sdk_forms_chat-settings/schemas';
export * as interactiveFormSessions from '@wix/auto_sdk_forms_interactive-form-sessions/schemas';
export * as forms from '@wix/auto_sdk_forms_forms/schemas';
export * as formSpamSubmissionReports from '@wix/auto_sdk_forms_form-spam-submission-reports/schemas';
export * as submissions from '@wix/auto_sdk_forms_submissions/schemas';
